import { createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      marginBottom: spacing(4),
    },
    cardHeader: {
      marginBottom: spacing(5),
    },
    cardTitle: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
    },
    checkboxesWrap: {
      display: 'flex',
      gap: spacing(4),
      marginBottom: spacing(4),
    },

    purchaserPriceInput: {},
    itemsLine: {
      width: '100%',
      marginBottom: spacing(6),
      gap: spacing(4),
      alignItems: 'flex-end',
    },
    itemsGap: {
      gap: spacing(4),
    },
    filter: {
      marginTop: spacing(4),
      width: '100%',
    },
    datePickers: {},
    datePickerContainer: {
      width: '100%',
    },
    commentsInput: {},
    label: {
      fontSize: 14,
      fontWeight: 500,
      color: `${colours.neutral[900]}`,
      marginBottom: spacing(2),
    },
    datePicker: {
      '& .MuiOutlinedInput-adornedStart': {
        width: '100%',
      },
    },
    descriptionInput: {},
    select: {
      backgroundColor: colors.white.lightest,
    },
    rootSelect: {
      width: '100%',
    },
    rootSelectTenure: {
      width: '100%',
      marginTop: spacing(1.5),
    },
    rootSelectWithBottomMargin: {
      width: '100%',
    },
    item: {
      flex: 1,
    },
    numberField: {
      flex: 1,
    },
    notInScheduleSelect: {
      width: `calc(50% - ${spacing(2)}px)`,
    },
    selectLabel: {
      fontSize: 14,
      fontWeight: 500,
      color: colors.kato.neutral[900],
      marginBottom: spacing(2),
    },
    textFieldWrap: {
      alignItems: 'end',
      width: '100%',
      flex: 1,
    },
    currencyAdornment: {
      color: '#7E8899', //TODO change after creating new palette
      paddingRight: spacing(2),
    },

    divider: {
      backgroundColor: colors.grey.light,
      height: 1,
      width: '100%',
      margin: spacing(4, 0),
    },
    defaultText: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
      fontWeight: 500,
      color: colors.grey.darker,
    },
    changeAssigneeBtn: {
      fontSize: 14,
      marginLeft: spacing(1),
      cursor: 'pointer',

      '&:hover': {
        color: colors.blue.darkish,
      },
    },
    userAutocomplete: {
      marginBottom: spacing(5),
    },
    twoColumnGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: spacing(4),
      width: '100%',
      marginBottom: spacing(4),
    },
    removeBottomMargin: {
      marginBottom: 0,
    },
    fullWidth: {
      gridColumn: '1 / -1',
    },
  });
